export const stylesMap = {
  container: {
    display: "flex",
    height: "100%",
    width: "100%vw",
    backgroundColor: "rgba(255, 255, 255, 0.926)",
    padding: "10px",
    border: "1px solid transparent",
    borderRadius: "10px",
  },
};
